























/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ArticleOwnerPaymentDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "StreamOwnerPayments"
	})
export default class StreamOwnerPayments extends Vue {
	@Prop() private data: ArticleOwnerPaymentDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Created (YYYY-MM-DD)", value: "created" },
		{ text: "Title", value: "title" },
		{ text: "Owner", value: "owner" },
		{ text: "Stream", value: "stream" },
		{ text: "Subscriber", value: "subscriber" },
	];
	private getFormat(date: Date) {
		return DateUtils.FormatDate(date, "YYYY-MM-DD");
	}
}
